<template>
  <div class="row ad-agent">
    <div class="col">
      <div class="row">
        <div class="d-flex justify-content-end col">
          <form class="form-inline py-2" @submit.prevent>
            <div class="input-group with-clear-icon">
              <input type="text" class="form-control" v-model="searchText" />
              <i
                class="ico ico-close"
                @click="clearSearchText"
                v-if="searchText.length > 0"
              ></i>
              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="row table-row">
        <div class="col">
          <table class="table ad-agent__clients-table">
            <thead>
              <tr>
                <th
                  v-for="item in tableHeaderItems"
                  :key="item.name"
                  :style="{
                    width:
                      (item.width * 100) /
                        tableHeaderItems
                          .map((x) => x.width)
                          .reduce((a, b) => a + b) +
                      '%',
                  }"
                >
                  <div class="table-th">{{ item.viewName }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="client in filterdClients"
                :class="{ 'tr-edit-mode': client.inEditing }"
                :key="client.id"
              >
                <td>
                  <div class="td-content" :title="client.name">
                    {{ client.name }}
                  </div>
                </td>
                <td>
                  <div class="td-content" :title="client.email">
                    {{ client.email }}
                  </div>
                </td>
                <td>
                  <div class="td-content" :title="client.phone">
                    {{ client.phone }}
                  </div>
                </td>
                <td>
                  <div class="td-content td-content--select">
                    <treeselect
                      :multiple="true"
                      :appendToBody="true"
                      :options="printMachineOptions"
                      :disabled="!client.inEditing"
                      placeholder="Выберите печатные машины..."
                      v-model="client.activePrintMachines"
                    />
                  </div>
                </td>
                <td>
                  <div class="td-content">
                    {{ client.isActive ? "Активирован" : "Не активирован" }}
                  </div>
                </td>
                <td align="center" v-if="!client.inEditing">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary px-3"
                    @click="removeAdAgent(client)"
                  >
                    <i class="ico ico-delete"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary px-3"
                    @click="editClient(client)"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                </td>
                <td align="center" v-else>
                  <button
                    type="button"
                    class="btn btn-sm btn-secondary px-3"
                    @click="cancelEditing(client)"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary px-3"
                    @click="saveEditedClient(client)"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api'
import roles from '../../../helpers/userRoles'
import Treeselect from '@riophae/vue-treeselect'
import { sortBy } from 'lodash'

const mapClient = (client) => {
  return {
    leid: client.legal_entity ? client.legal_entity.id : null,
    id: client.id,
    name: client.name,
    email: client.email,
    phone: client.telephone,
    adAgent: client.ad_agent,
    isActive: client.userIsActive,
    inEditing: false,
    activePrintMachines: client.activePrintMachines || []
  }
}

const mapPrintMachine = (printMachine) => {
  return {
    id: printMachine.id,
    name: printMachine.name
  }
}

export default {
  name: 'AdAgent',
  components: {
    Treeselect
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      clients: [],
      printMachines: [],
      tableHeaderItems: [],
      tempClients: [],
      searchText: ''
    }
  },
  methods: {
    loadClients () {
      api.get
        .clients()
        .then((resp) => {
          this.clients = resp.data.data.clients
            .filter((x) => x.ad_agent)
            .map(mapClient)
            .sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1
              }
              return 0
            })
          this.searchText = ''
        })
        .catch(() =>
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        )
    },
    loadPrintMachines () {
      api.get
        .printMachines()
        .then((resp) => {
          const printMachines = resp.data.data.printMachines.map(
            mapPrintMachine
          )
          this.printMachines = sortBy(printMachines, (pm) =>
            pm.name.toLowerCase()
          )
        })
        .catch((ex) =>
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        )
    },
    setTableHeader () {
      this.tableHeaderItems = [
        {
          name: 'name',
          viewName: 'ФИО',
          width: 175
        },
        {
          name: 'email',
          viewName: this.$t('home.email'),
          width: 150
        },
        {
          name: 'phone',
          viewName: this.$t('home.phone'),
          width: 150
        },
        {
          name: 'calculator',
          viewName: 'Печатные машины',
          width: 200
        },
        {
          name: 'status',
          viewName: 'Статсус',
          width: 125
        },
        {
          name: 'actions',
          viewName: '',
          width: 125
        }
      ]
    },
    editClient (client) {
      this.tempClients.push({ ...client })
      client.inEditing = true
    },
    cancelEditing (client) {
      const savedClientIndex = this.tempClients.findIndex(
        (x) => x.id === client.id
      )
      const savedClient = this.tempClients[savedClientIndex]
      const clientIndex = this.clients.findIndex((x) => x.id === client.id)
      this.clients.splice(clientIndex, 1, savedClient)
      this.tempClients.splice(savedClientIndex, 1)
    },
    async saveEditedClient (client) {
      try {
        await api.post.adAgentPrintMachines(
          client.id,
          client.activePrintMachines
        )
        const savedClientIndex = this.tempClients.findIndex(
          (x) => x.id === client.id
        )
        this.tempClients.splice(savedClientIndex, 1)
        client.inEditing = false
      } catch (ex) {
        this.cancelEditing(client)
      }
    },
    clearSearchText () {
      this.searchText = ''
    },
    removeAdAgent (client) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              client.adAgent = false
              api.post
                .updateClient(client, client.id)
                .then(() => {
                  const clientIndex = this.clients.findIndex(
                    (x) => x.id === client.id
                  )
                  this.clients.splice(clientIndex, 1)
                })
                .catch(() => {
                  this.$notify({
                    message: 'Произошла ошибка',
                    type: 'danger'
                  })
                })
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    }
  },
  computed: {
    printMachineOptions () {
      return this.printMachines.map((pm) => {
        return {
          id: pm.id,
          label: pm.name
        }
      })
    },
    isUserCanViewAdAgent () {
      return this.$store.getters.role === roles.director
    },
    filterdClients () {
      if (this.searchText) {
        return this.clients.filter((f) =>
          Object.values(f).some(
            (x) => x?.toString().toLowerCase().indexOf(this.searchText) >= 0
          )
        )
      }

      return this.clients
    }
  },
  async created () {
    if (!this.isUserCanViewAdAgent) {
      this.$router.push('/')
    }
    await this.loadPrintMachines()
    this.loadClients()
    this.setTableHeader()
  }
}
</script>

<style lang="scss" scoped>
.ad-agent {
  &__clients-table {
    .td-content {
      height: auto;

      &--select {
        overflow: initial;
        text-overflow: initial;
        white-space: initial;
      }
    }
  }
}
</style>
